import { render, staticRenderFns } from "./listMemberAuction.vue?vue&type=template&id=354ed736&scoped=true"
import script from "./listMemberAuction.vue?vue&type=script&lang=js"
export * from "./listMemberAuction.vue?vue&type=script&lang=js"
import style0 from "./listMemberAuction.vue?vue&type=style&index=0&id=354ed736&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ed736",
  null
  
)

export default component.exports